var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 23.5306V9.64583C3.60938 6.36188 6.27398 3.69727 9.55793 3.69727H12.9571",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4431 7.24023V19.1374C23.4431 21.5571 21.4698 23.5304 19.0501 23.5304H9.02539",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66406 9.28516L19.2073 19.814",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2361 9.28516L8.66406 19.814",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDark);
export default __webpack_public_path__ + "static/media/DELETE __ DARK.43a3b040ebeef49df7118f317fb206ce.svg";
export { ForwardRef as ReactComponent };